<template>
    <div class="row" style = "margin-left: -30px; margin-right: -30px;">
        <div class="w-100">{{ 'bonus_stage' | lang }} = {{scenario.amount_won | currency}}</div>
        <table class ="table" style="border:none; table-layout: fixed;"> 
            <tr class="" v-for="(row, index) in guesses" :key="index">
                <td v-for="(guessItem, guessItemIndex) in row" :key="guessItemIndex" :style="`border: 1px solid rgba(255,255,255,0.3);padding: 7px; vertical-align: middle;`">
                    <div :style = "!guessItem.lucky ? 'opacity:0.3;' : ''"> 
                        <span v-for="(item, itemIndex) in parseNumbers(`X${guessItem.guess}`)" :key="itemIndex">
                            <img :src="`/sl/v1/games/vienas_namuose/img/bonus/Counter/Red/${item}.png`" :alt="item" class="img-fluid" :style="`height: 30px;`">
                        </span>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    props: ['scenarios', 'amount'],
    data() {
        return {
        };
    },
    methods: {
        parseNumbers(number) {
            let amountSymbolsCount = String(number);
            let items = [];

            for (let i = 0; i < amountSymbolsCount.length; i++) {
                let spriteName = amountSymbolsCount[i];

                switch(amountSymbolsCount[i]) {
                    case '.':
                        spriteName = 'Dot';
                        break;
                    case ',':
                        spriteName = 'Comma';
                        break;
                }

                items.push(spriteName);
            }

            return items;
        }
    },
    computed: {
        scenario() {
            return this.scenarios.filter(function (scenario) {
                return scenario.bonus_stage;
            })[0];
        },
        guesses() {
            let table = [];
            let ordered = {};
            let absoluteIndex = 0;


            this.scenario.choice.forEach((pickedMicIndex, index) => { 
                ordered[pickedMicIndex] = {'guess':this.scenario['bonus_stage']['guesses'][absoluteIndex], 'lucky':true};
                absoluteIndex++;
            });  
            
            for(let i = 0; i < 6; i++) {
                if(!this.scenario.choice.includes(i)) {
                    ordered[i] = {'guess':this.scenario['bonus_stage']['guesses'][absoluteIndex], 'lucky':false};
                    absoluteIndex++;
                }
            }

            let tableIndex = 0;
            
            for (const [ index, item ] of Object.entries(ordered)) {
                if(!table[tableIndex]) {
                    table[tableIndex] = [];
                }

                table[tableIndex].push(item);

                if(table[tableIndex].length > 2) {
                    tableIndex++
                }
            }

            return table;
        }
    },
}
</script>